import React, {
  useEffect,
  // useRef, 
  useState
} from "react";
import "./Radius.css";

import {geodesicBuffer} from "@arcgis/core/geometry/geometryEngine";
// import SketchViewModel from "@arcgis/core/widgets/Sketch/SketchViewModel";
import Graphic from "@arcgis/core/Graphic";
import {addressToLocations} from "@arcgis/core/rest/locator";

interface iProps {
  mapView: React.MutableRefObject<__esri.MapView>;
  sketchLayer: React.MutableRefObject<__esri.GraphicsLayer>;
  highlightSymbol: React.MutableRefObject<__esri.SimpleFillSymbol>;
  centerPoint: __esri.Point | undefined;
  setCenterPoint: React.Dispatch<React.SetStateAction<__esri.Point | undefined>>;
  setRadiusGeometry: React.Dispatch<React.SetStateAction<__esri.Polygon | null>>;
  searchText: string;
  setSearchText: React.Dispatch<React.SetStateAction<string>>;
  showMap: () => void;
}

const distanceOptions = [25, 50, 100, 150, 300, 500];

export default function Radius(props: iProps) {
  const {
    mapView,
    sketchLayer,
    highlightSymbol,
    centerPoint,
    setCenterPoint,
    setRadiusGeometry,
    searchText,
    setSearchText,
    // showMap
  } = props;

  const [radiusDistance, setRadiusDistance] = useState<number | ''>(100);
  const [radiusUnits, setRadiusUnits] = useState('miles');

  const onRadiusDistanceChange = (evt: any) => {
    const distance = parseFloat(evt.target.value);
    if (!isNaN(distance)) {
      setRadiusDistance(distance);
    } else {
      setRadiusDistance('');
    }
  }

  const onRadiusUnitsChange = (evt: any) => {
    setRadiusUnits(evt.target.value);
  }

  const calculateRadiusBuffer = () => {
    if (centerPoint && radiusDistance !== '' && radiusDistance > 0) {
      const buffer = geodesicBuffer(centerPoint, radiusDistance, radiusUnits as __esri.LinearUnits, true) as __esri.Polygon;
      setRadiusGeometry(buffer);
      mapView.current?.goTo(buffer);

      let graphics = sketchLayer.current.graphics.filter(x => x.geometry.type === 'polygon').toArray();
      sketchLayer.current.removeMany(graphics);

      sketchLayer.current.add(new Graphic({
        geometry: buffer,
        symbol: highlightSymbol.current
      }));
    }
  }
  useEffect(calculateRadiusBuffer, [centerPoint, radiusDistance, radiusUnits, setRadiusGeometry, sketchLayer, highlightSymbol, mapView]);

  const clear = () => {
    sketchLayer.current.removeAll();
    setCenterPoint(undefined);
    setRadiusGeometry(null);
    setSearchText('');
  }

  const onSearchTextChange = (evt: any) => {
    setSearchText(evt.target.value);
  }

  const search = () => {
    const geocodeServiceUrl = 'http://geocode-api.arcgis.com/arcgis/rest/services/World/GeocodeServer'
    addressToLocations(geocodeServiceUrl, {
      address: {SingleLine: searchText},
      maxLocations: 1,
      outFields: [],
      outSpatialReference: mapView.current?.spatialReference
    }).then(candidates => {
      if (candidates.length > 0) {
        const location = candidates[0].location;
        setCenterPoint(location);
      }
      else {
        setCenterPoint(undefined);
      }
    }).catch(console.error);
  }

  return (
    <div className="radius">
      <div className="pl-1">Within</div>
      <select value={radiusDistance}
        onChange={onRadiusDistanceChange}>
        {distanceOptions.map((x, i) => <option key={i} value={x}>{x}</option>)}
      </select>
      <select value={radiusUnits}
        onChange={onRadiusUnitsChange}>
        <option value='miles'>Miles</option>
        <option value='kilometers'>Kilometers</option>
      </select>
      <div className="pl-1">of</div>
      <input type='text'
        placeholder="City or Zip Code"
        value={searchText}
        onChange={onSearchTextChange}
        onKeyDown={(evt) => {if (evt.key === 'Enter') {search()} }}
      />
      <div className="pl-1 small-text">Enter City or Zip Code</div>
      <button onClick={search}>Search</button>
      <button onClick={clear}>Clear Radius</button>
    </div>
  );
}